export const USER_REGISTER = 'OD/USER_REGISTER'
export const USER_REGISTER_LOADING = 'OD/USER_REGISTER_LOADING'
export const USER_REGISTER_PENDING_REVIEW = 'OD/USER_REGISTER_PENDING_REVIEW'
export const USER_REGISTER_FAILURE = 'OD/USER_REGISTER_FAILURE'

export interface UserRegisterAction {
  readonly type: typeof USER_REGISTER;
  readonly payload: { firstName:string, lastName:string, email:string };
}

export const submitUserRegister = (
  email: string,
  firstName: string,
  lastName: string,
): UserRegisterAction => ({
  type: USER_REGISTER,
  payload: {firstName, lastName, email }
})

export interface UserRegisterLoadingAction {
  readonly type: typeof USER_REGISTER_LOADING;
  readonly payload: { email:string };
}

export const startUserRegister = (
  email: string
) => ({
  type: USER_REGISTER_LOADING,
  payload: { email },
})

export interface PromptRegisterPendingReviewAction {
  readonly type: typeof USER_REGISTER_PENDING_REVIEW;
  readonly payload: { email: string };
}

export const promptRegisterPendingReview = (email:string): PromptRegisterPendingReviewAction => ({
  type: USER_REGISTER_PENDING_REVIEW,
  payload: {
    email
  },
})

export interface ReportRegisterFailureAction {
  readonly type: typeof USER_REGISTER_FAILURE;
  readonly payload: { errMsg: string, domainExists?: boolean };
}

export const reportRegisterFailure = (errMsg:string, domainExists?:boolean): ReportRegisterFailureAction => ({
  type: USER_REGISTER_FAILURE,
  payload: {
    errMsg,
    domainExists,
  },
})
